if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


//custom code
// Trade 15.x: Clearance notice toggle that survives section re-renders
(() => {
  // Prevent double-binding if the file is loaded twice
  if (window.__tradeClearanceNoticeBound) return;
  window.__tradeClearanceNoticeBound = true;

  function computeIsClearance(vs) {
    const select = vs.querySelector('select[data-variant-clearance-select]');
    if (!select) return false;

    const opt = select.options?.[select.selectedIndex];
    return opt?.getAttribute('data-clearance') === 'true';
  }

  function applyToVariantSelects(vs) {
    if (!vs) return;

    const notice = vs.querySelector('[data-variant-clearance-notice]');
    if (!notice) return;

    const isClearance = computeIsClearance(vs);
    notice.toggleAttribute('hidden', !isClearance);
  }

  function applyAll(root = document) {
    root.querySelectorAll('variant-selects').forEach(applyToVariantSelects);
  }

  // Run now + on load
  document.addEventListener('DOMContentLoaded', () => applyAll());

  // 1) Hook into theme pubsub if present (runs during option selection pipeline)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        const vs =
          data?.event?.target?.closest?.('variant-selects') ||
          data?.target?.closest?.('variant-selects');

        if (!vs) return;

        // Apply immediately, then again after Trade finishes any DOM swaps.
        applyToVariantSelects(vs);
        requestAnimationFrame(() => applyToVariantSelects(vs));
        setTimeout(() => applyToVariantSelects(vs), 0);
        setTimeout(() => applyToVariantSelects(vs), 50);
        setTimeout(() => applyToVariantSelects(vs), 200);
      });
    } catch (e) {
      // ignore
    }
  }

  // 2) Also listen to native change (capture) as a fallback
  document.addEventListener(
    'change',
    (e) => {
      const el = e.target;
      if (!(el instanceof HTMLSelectElement)) return;
      if (!el.matches('select[data-variant-clearance-select]')) return;

      const vs = el.closest('variant-selects');
      if (!vs) return;

      applyToVariantSelects(vs);
      requestAnimationFrame(() => applyToVariantSelects(vs));
      setTimeout(() => applyToVariantSelects(vs), 0);
      setTimeout(() => applyToVariantSelects(vs), 50);
      setTimeout(() => applyToVariantSelects(vs), 200);
    },
    true
  );

  // 3) MOST IMPORTANT for Trade: watch for DOM replacements and re-apply
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // If Trade swapped a chunk of HTML, new variant-selects/notice nodes appear.
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          // If the added node *is* variant-selects or contains it
          if (node.matches?.('variant-selects')) {
            applyToVariantSelects(node);
          } else if (node.querySelector?.('variant-selects')) {
            node.querySelectorAll('variant-selects').forEach(applyToVariantSelects);
          }
        });
        // No need to keep scanning this mutation after handling additions
        break;
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Theme editor reloads
  document.addEventListener('shopify:section:load', (e) => applyAll(e.target));
})();
